import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { PanelService } from 'src/app/panel/services/panel.service';
import { ConfigurationService } from 'src/app/shared/services/configuration.service';
import { NavbarPanel, NavbarConfig } from 'src/app/shared/models/configuration';
import { configSections } from 'src/app/profile-config/services/user-config-panel.service';
import { UserConfigPanelService } from 'src/app/profile-config/services/user-config-panel.service';

interface PanelOption {
  key: NavbarPanel;
  name: string;
  description: string;
  enabled: boolean;
  permission : string;
  sectionConfig? : string // caso especial para vehiculo
  drawerNewHistory? : string // caso especial para nuevo historial
  iconSection? : string // para los iconos de vehiculos
}

@Component({
  selector: 'app-user-panel-visibility',
  templateUrl: './user-panel-visibility.component.html',
  styleUrls: ['./user-panel-visibility.component.scss', './../components-conf.scss']
})
export class UserPanelVisibilityComponent implements OnInit {
  public panels : any[] = [];

  public filterPanel : string = "";
  private panelMetadata: Omit<PanelOption, 'enabled'>[] = [
    { key: 'alertas', name: 'Alertas', description: 'Panel de notificaciones y alertas activas', permission: 'alerts_module', sectionConfig : configSections.ALERT_CONFIG },
    { key: 'auditoria', name: 'Auditoría', description: 'Revisión de acciones y registros del sistema', permission: 'audits_module' },
    { key: 'conductores', name: 'Conductores', description: 'Listado y administración de conductores', permission: 'drivers_module', sectionConfig : configSections.DRIVERS_CONFIG},
    { key: 'dashboard', name: 'Dashboard', description: 'Panel de control general', permission: 'dashboard_module' },
    { key: 'eventos', name: 'Eventos', description: 'Registro y seguimiento de eventos importantes', permission: 'events_module', sectionConfig : configSections.EVENTS_CONFIG},
    { key: 'geocercas', name: 'Geocercas', description: 'Administración de zonas delimitadas', permission: 'geofences_module', sectionConfig : configSections.GEOFENCE_CONFIG },
    { key: 'geopuntos', name: 'Geopuntos', description: 'Visualización y gestión de puntos geográficos', permission: 'geopoints_module', sectionConfig : configSections.GEOPOINTS_CONFIG},
    { key: 'historial', name: 'Historial', description: 'Registro histórico de movimientos', permission: 'histories_module', sectionConfig : configSections.HISTORY_CONFIG, drawerNewHistory : configSections.HISTORY_DRAWER_CONFIGURATION},
    { key: 'multipantalla', name: 'Multipantalla', description: 'Vista simultánea de múltiples paneles', permission: 'multiscreen_module' },
    { key: 'reportes', name: 'Reportes', description: 'Generación de informes y estadísticas', permission: 'reports_module' },
    { key: 'subcuentas', name: 'Subcuentas', description: 'Gestión de cuentas secundarias', permission: 'subaccounts_module' },
    { key: 'vehiculos', name: 'Vehículos', description: 'Muestra la lista y estado de los vehículos', permission: 'vehicles_module', sectionConfig : configSections.VEHICLE_CONFIG, iconSection : configSections.ICONS_CONFIGURATION}
  ];

  constructor(
    panelService : PanelService,
    public configurationService : ConfigurationService,
    public userConfigPanel : UserConfigPanelService
  ) { 
  }

  ngOnInit(): void {
    this.configurationService.navbarConfig$.subscribe((config: NavbarConfig) => {
      this.panels = this.panelMetadata.map(meta => ({
        ...meta,
        enabled: config.showpanels[meta.key]
      }));
    });
  }

  updatePanelVisibility(key: NavbarPanel, enabled: boolean) {
    const currentConfig = this.configurationService.navbarConfigSubject.getValue();

    this.configurationService.setNavbarConfig({
      showpanels: {
        ...currentConfig.showpanels,
        [key]: enabled
      }
    });
  }

  trackByKey(index: number, item: PanelOption): string {
    return item.key;
  }

  public openConfig(section : string){
    this.userConfigPanel.setSelectedSection(section)
  }

}
